module.exports = __webpack_public_path__ + "img/btn-jc-bg2.971c6b85.png";